import { useCallback, useState } from 'react';

const initialConfig = {
  type: 'success',
  content: '',
  onConfirm: null,
  onCancel: null,
};

function useDialog() {
  const [showDialog, setShowDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dialogConfig, setDialogConfig] = useState(initialConfig);

  const show = useCallback(
    ({
      type, content, onConfirm = null, onCancel = null,
    }) => {
      const defaultConfirm = async () => {
        if (onConfirm) {
          setIsLoading(true);
          await onConfirm(setShowDialog);
          setIsLoading(false);
          return;
        }
        setShowDialog(false);
      };

      const defaultCancel = async () => {
        if (onCancel) {
          setIsLoading(true);
          await onCancel(setShowDialog);
          setIsLoading(false);
          return;
        }
        setShowDialog(false);
      };

      setDialogConfig({
        show: true,
        type,
        content,
        onConfirm: defaultConfirm,
        onCancel: defaultCancel,
      });

      setShowDialog(true);
    },
    [setDialogConfig, setShowDialog, setIsLoading],
  );

  return {
    config: { showDialog, isLoading, ...dialogConfig },
    show,
  };
}

export default useDialog;
